import { createFileRoute, redirect } from "@tanstack/react-router";

/** Subscriptions are services (ADR 0031), which live in the offer (ADR 0035): old links land there. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders
export const Route = createFileRoute("/(private)/finances/subscriptions/")({
  beforeLoad: () => {
    throw redirect({ to: "/offer", replace: true });
  },
});
